import AppBase from './app/AppBase';
import PushpinsControl from './services/lmv/pushpins-control';
import { viewTypes } from './constants/view-types';

import {
  enablePushpinWorkflowAction,
} from './redux/actions';

export default class extends AppBase {

  constructor() {
    super(...arguments);

    this.defaultRoute = '/rfis';
    this.viewType = viewTypes.DOCUMENT;
  }

  configureExternalControls() {
    this.pushpinsControl = new PushpinsControl();
  }

  setPushpinExtension(pushpinExtension) {
    // TODO - Temp fix for RFI void pushpin color - remove this once fix for https://jira.autodesk.com/browse/BLMV-2445 is updated in Docs
    if (pushpinExtension && pushpinExtension.updatePattern) {
      pushpinExtension.updatePattern('rfis-void', 80, '#bcc9d1');
      pushpinExtension.updatePattern('rfis-void-selected', 90, '#bcc9d1');
    }

    this.pushpinsControl.pushpinExtension = pushpinExtension;
  }

  enablePushpinWorkflow() {
    this.store.dispatch(enablePushpinWorkflowAction(true));
  }

  disablePushpinWorkflow() {
    this.store.dispatch(enablePushpinWorkflowAction(false));
  }
}
